/** @module Enums */ /** typedoc */
/* tslint:disable */
var RegexPatterns;
(function (RegexPatterns) {
    RegexPatterns["Email"] = "^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$";
    RegexPatterns["Duration"] = "^([0-5]?[0-9])?(:[0-5]?[0-9])$";
})(RegexPatterns || (RegexPatterns = {}));
/* tslint:enable */

export { RegexPatterns };
